import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./AddPurchase.css"; // keep consistent styling
import axios from "axios";
import { useParams } from "react-router-dom";

const EditCustomer = () => {
  const [customer, setCustomer] = useState({});
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { user_id } = useParams();
  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [file, setFile] = React.useState(null);

  // const uploadImage = async () => {
  //   const formData = new FormData();
  //   formData.append("image", file);
  //   console.log(data);
  // };

  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    date_of_birth: "",
    email: "",
    mobile: "",
    address: "",
    blood: "",
    aadhar: "",
    pan_card: "",
    depart_id: "",
    desig_id: "",
    staff_type: "",
    date_of_join: "",
    total_leave: "0",
    taken_leave: "0",
    remaining_leave: "0",
    total_leave_ml: "0",
    taken_leave_ml: "0",
    remaining_leave_ml: "0",
    total_leave_rl: "0",
    taken_leave_rl: "0",
    remaining_leave_rl: "0",
    total_leave_el: "0",
    taken_leave_el: "0",
    remaining_leave_el: "0",
    total_leave_uel: "0",
    taken_leave_uel: "0",
    remaining_leave_uel: "0",
    maternity_leave: "0",
    od_count: "0",
    total_permission: "0",
    taken_permission: "0",
    remaining_permission: "0",
    basic_salary: "0.00",
    password: "",
    image: null,
    imageDimensions: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    axios.post(`${API_BASE_URL}department_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setDepartmentList(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setDepartmentList([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setDepartmentList([]);
      }).finally(() => {
      });

    axios.post(`${API_BASE_URL}designation_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setDesignationList(response.data.body);
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setDesignationList([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setDesignationList([]);
      }).finally(() => {
      });

    axios.post(`${API_BASE_URL}user_detail.php`, { user_id: user_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setFormData(response.data.body);
          const apiData = response.data.body;

      // convert DD-MM-YYYY → YYYY-MM-DD
      const convertToInputDate = (dateStr) => {
        if (!dateStr) return "";
        const [dd, mm, yyyy] = dateStr.split("-");
        return `${yyyy}-${mm}-${dd}`;
      };

      const updatedData = {
        ...apiData,
        date_of_birth: convertToInputDate(apiData.date_of_birth),
        date_of_join: convertToInputDate(apiData.date_of_join),
      };

      setFormData(updatedData);
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setCustomer([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setCustomer([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  const handleChange = (e) => {
  const { name, value, files } = e.target;

  if (name === "image") {
    const file = files[0];

    if (file) {
      // Read image dimensions
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = () => {
        // Convert to Base64
        const reader = new FileReader();
        reader.onloadend = () => {
          setFormData((prev) => ({
            ...prev,
            image: reader.result, // BASE64 STRING
            imageDimensions: `${img.width} × ${img.height}px`,
          }));
        };

        reader.readAsDataURL(file); // Convert to Base64
      };
    } else {
      setFormData((prev) => ({
        ...prev,
        image: null,
        imageDimensions: "",
      }));
    }
  } else {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }
};


  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.date_of_birth) newErrors.date_of_birth = "Date of birth is required";
    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Valid email is required";
    if (!formData.mobile || !/^\d{10}$/.test(formData.mobile))
      newErrors.mobile = "Valid 10-digit contact number is required";
    // if (!formData.address.trim()) newErrors.address = "Address is required";
    // if (!formData.blood) newErrors.blood = "Blood group is required";
    // if (!formData.aadhar || !/^\d{12}$/.test(formData.aadhar))
    //   newErrors.aadhar = "Valid 12-digit Aadhar number is required";
    // if (!formData.pan_card || !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.pan_card))
    //   newErrors.pan_card = "Valid PAN number is required";
    if (!formData.total_leave) newErrors.total_leave = "Total Leave is required";
    if (!formData.basic_salary) newErrors.basic_salary = "Salary is required";
    // if (!formData.qualification.trim())
    //   newErrors.qualification = "Qualification is required";
    if (!formData.depart_id) newErrors.depart_id = "Department is required";
    if (!formData.desig_id) newErrors.desig_id = "Designation is required";
    // if (!formData.usertype) newErrors.usertype = "User type is required";
    if (!formData.staff_type) newErrors.staff_type = "Staff type is required";
    if (!formData.date_of_join) newErrors.date_of_join = "Date of joining is required";
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
       const payload = { ...formData };
      setErrors({});
      console.log("Updated Customer:", formData);
      // send update to backend here
      /* */
      axios.post(`${API_BASE_URL}user_detail_edit.php`,payload)
      .then((response) => {
        if (response.data.head.code === 200) {
          window.history.back();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      }).finally(() => {
      });
      
    }
  };

  const renderError = (field) =>
    errors[field] ? (
      <div className="text-danger small mt-1">{errors[field]}</div>
    ) : null;

    useEffect(() => {
        const remaining_leave =
          (Number(formData.total_leave) || 0) -
          (Number(formData.taken_leave) || 0);
    
        setFormData((prev) => ({
          ...prev,
          total_leave: formData.total_leave,
          taken_leave: formData.taken_leave,
          remaining_leave: remaining_leave,
        }));
      }, [
        formData.total_leave,
        formData.taken_leave,
        formData.remaining_leave,
      ]);

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Edit User</h4>
        <Button className="btn-top" onClick={() => window.history.back()}>
          Back
        </Button>
      </div>

      <Form onSubmit={handleSubmit} noValidate>
        <Row className="g-3">
          {/* Text Inputs */}
          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Name"
              />
              {renderError("name")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Gender</Form.Label>
              <Form.Select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </Form.Select>
              {renderError("gender")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Date of Birth</Form.Label>
              <Form.Control
                name="date_of_birth"
                type="date"
                value={formData.date_of_birth}
                onChange={handleChange}
              />
              {renderError("date_of_birth")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="name@example.com"
              />
              {renderError("email")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Contact Number</Form.Label>
              <Form.Control
                name="mobile"
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={10}
                value={formData.mobile}
                onChange={handleChange}
                placeholder="10-digit phone number"
              />
              {renderError("mobile")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Residential Address</Form.Label>
              <Form.Control
                name="address"
                as="textarea"
                rows={2}
                value={formData.address}
                onChange={handleChange}
                placeholder="Street, city, state, pincode"
              />
              {renderError("address")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Blood Group</Form.Label>
              <Form.Select
                name="blood"
                value={formData.blood}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Blood Group</option>
                {["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].map(
                  (bg) => (
                    <option key={bg} value={bg}>
                      {bg}
                    </option>
                  )
                )}
              </Form.Select>
              {renderError("blood")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Aadhar Number</Form.Label>
              <Form.Control
                name="aadhar"
                type="text"
                inputMode="numeric"
                maxLength={12}
                value={formData.aadhar}
                onChange={handleChange}
                placeholder="12-digit Aadhar"
              />
              {renderError("aadhar")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>PAN Card Number</Form.Label>
              <Form.Control
                name="pan_card"
                type="text"
                maxLength={10}
                value={formData.pan_card}
                onChange={(e) =>
                  setFormData({ ...formData, pan_card: e.target.value.toUpperCase() })
                }
                placeholder="ABCDE1234F"
              />
              {renderError("pan_card")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Department</Form.Label>
              <Form.Select
                name="depart_id"
                value={formData.depart_id}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Department</option>
                {departmentList.map((department) => (
                  <option key={department.depart_id} value={department.depart_id}>
                    {department.depart_name}
                  </option>
                ))}
              </Form.Select>
              {renderError("depart_id")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Designation</Form.Label>
              <Form.Select
                name="desig_id"
                value={formData.desig_id}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Designation</option>
                {designationList.map((designation) => (
                  <option key={designation.desig_id} value={designation.desig_id}>
                    {designation.desig_name}
                  </option>
                ))}
              </Form.Select>
              {renderError("desig_id")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Staff Type</Form.Label>
              <Form.Select
                name="staff_type"
                value={formData.staff_type}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Staff Type</option>
                {["Aided", "Self Financing"].map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </Form.Select>
              {renderError("staff_type")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Date of Joining</Form.Label>
              <Form.Control
                name="date_of_join"
                type="date"
                value={formData.date_of_join}
                onChange={handleChange}
              />
              {renderError("date_of_join")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Password</Form.Label>
              <Form.Control
                name="password"
                type="text"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value.toUpperCase() })}
                placeholder="Password"
              />
              {renderError("password")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Upload Photo <span className="text-muted small">(Max 2MP)</span></Form.Label>
              <Form.Control
                name="image"
                type="file"
                accept="image/*"
                onChange={handleChange}
              />
              {formData.imageDimensions && (
                <div className="text-muted small mt-1">
                  Dimensions: {formData.imageDimensions}
                </div>
              )}
              {formData.image && (
                <div className="mt-2">
                  <img
                    // src={URL.createObjectURL(formData.image)}
                    src={formData.image}

                    alt="Preview"
                    width="50"
                    height="50"
                    style={{
                      objectFit: "cover",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                    }}
                  />
                </div>
              )}
            </Form.Group>
          </Col>
{formData.desig_id !== "1" && formData.desig_id !== "2" && (
  <>
          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Total Leave(CL)</Form.Label>
              <Form.Control
                name="total_leave"
                type="text"
                value={formData.total_leave}
                onChange={(e) => setFormData({ ...formData, total_leave: e.target.value.toUpperCase() })}
                placeholder="0"
              />
              {renderError("total_leave")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Taken Leave(CL)</Form.Label>
              <Form.Control
                name="taken_leave"
                type="text"
                value={formData.taken_leave}
                onChange={(e) => setFormData({ ...formData, taken_leave: e.target.value.toUpperCase() })}
                placeholder="0"
              />
              {renderError("taken_leave")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Remaining Leave(CL)</Form.Label>
              <Form.Control
                name="remaining_leave"
                type="text"
                value={formData.remaining_leave > 0 ? formData.remaining_leave : "0"}
                onChange={(e) => setFormData({ ...formData, remaining_leave: e.target.value.toUpperCase() })}
                placeholder="0"
              />
              {renderError("remaining_leave")}
            </Form.Group>
          </Col>
</>
)}
          {formData.staff_type == "Aided" && formData.desig_id !== "1" && (
                      <>
                        <Col lg={4} md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Total Leave(ML)</Form.Label>
                            <Form.Control
                              name="total_leave_ml"
                              type="text"
                              value={formData.total_leave_ml}
                              onChange={(e) => setFormData({ ...formData, total_leave_ml: e.target.value.toUpperCase() })}
                              placeholder="0"
                            />
                            {renderError("total_leave_ml")}
                          </Form.Group>
                        </Col>
          
                        <Col lg={4} md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Taken Leave(ML)</Form.Label>
                            <Form.Control
                              name="taken_leave_ml"
                              type="text"
                              value={formData.taken_leave_ml}
                              onChange={(e) => setFormData({ ...formData, taken_leave_ml: e.target.value.toUpperCase() })}
                              placeholder="0"
                            />
                            {renderError("taken_leave_ml")}
                          </Form.Group>
                        </Col>
          
                        <Col lg={4} md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Remaining Leave(ML)</Form.Label>
                            <Form.Control
                              name="remaining_leave_ml"
                              type="text"
                              value={formData.remaining_leave_ml}
                              onChange={(e) => setFormData({ ...formData, remaining_leave_ml: e.target.value.toUpperCase() })}
                              placeholder="0"
                            />
                            {renderError("remaining_leave_ml")}
                          </Form.Group>
                        </Col>
                        <Col lg={4} md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Total Leave(RL)</Form.Label>
                            <Form.Control
                              name="total_leave_rl"
                              type="text"
                              value={formData.total_leave_rl}
                              onChange={(e) => setFormData({ ...formData, total_leave_rl: e.target.value.toUpperCase() })}
                              placeholder="0"
                            />
                            {renderError("total_leave_rl")}
                          </Form.Group>
                        </Col>
          
                        <Col lg={4} md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Taken Leave(RL)</Form.Label>
                            <Form.Control
                              name="taken_leave_rl"
                              type="text"
                              value={formData.taken_leave_rl}
                              onChange={(e) => setFormData({ ...formData, taken_leave_rl: e.target.value.toUpperCase() })}
                              placeholder="0"
                            />
                            {renderError("taken_leave_rl")}
                          </Form.Group>
                        </Col>
          
                        <Col lg={4} md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Remaining Leave(RL)</Form.Label>
                            <Form.Control
                              name="remaining_leave_rl"
                              type="text"
                              value={formData.remaining_leave_rl}
                              onChange={(e) => setFormData({ ...formData, remaining_leave_rl: e.target.value.toUpperCase() })}
                              placeholder="0"
                            />
                            {renderError("remaining_leave_rl")}
                          </Form.Group>
                        </Col>
          
                        <Col lg={4} md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Total Leave(EL)</Form.Label>
                            <Form.Control
                              name="total_leave_el"
                              type="text"
                              value={formData.total_leave_el}
                              onChange={(e) => setFormData({ ...formData, total_leave_el: e.target.value.toUpperCase() })}
                              placeholder="0"
                            />
                            {renderError("total_leave_el")}
                          </Form.Group>
                        </Col>
          
                        <Col lg={4} md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Taken Leave(EL)</Form.Label>
                            <Form.Control
                              name="taken_leave_el"
                              type="text"
                              value={formData.taken_leave_el}
                              onChange={(e) => setFormData({ ...formData, taken_leave_el: e.target.value.toUpperCase() })}
                              placeholder="0"
                            />
                            {renderError("taken_leave_el")}
                          </Form.Group>
                        </Col>
          
                        <Col lg={4} md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Remaining Leave(EL)</Form.Label>
                            <Form.Control
                              name="remaining_leave_el"
                              type="text"
                              value={formData.remaining_leave_el}
                              onChange={(e) => setFormData({ ...formData, remaining_leave_el: e.target.value.toUpperCase() })}
                              placeholder="0"
                            />
                            {renderError("remaining_leave_el")}
                          </Form.Group>
                        </Col>
                        <Col lg={4} md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Total Leave(UEL)</Form.Label>
                            <Form.Control
                              name="total_leave_uel"
                              type="text"
                              value={formData.total_leave_uel}
                              onChange={(e) => setFormData({ ...formData, total_leave_uel: e.target.value.toUpperCase() })}
                              placeholder="0"
                            />
                            {renderError("total_leave_uel")}
                          </Form.Group>
                        </Col>
          
                        <Col lg={4} md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Taken Leave(UEL)</Form.Label>
                            <Form.Control
                              name="taken_leave_uel"
                              type="text"
                              value={formData.taken_leave_uel}
                              onChange={(e) => setFormData({ ...formData, taken_leave_uel: e.target.value.toUpperCase() })}
                              placeholder="0"
                            />
                            {renderError("taken_leave_uel")}
                          </Form.Group>
                        </Col>
          
                        <Col lg={4} md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Remaining Leave(UEL)</Form.Label>
                            <Form.Control
                              name="remaining_leave_uel"
                              type="text"
                              value={formData.remaining_leave_uel}
                              onChange={(e) => setFormData({ ...formData, remaining_leave_uel: e.target.value.toUpperCase() })}
                              placeholder="0"
                            />
                            {renderError("remaining_leave_uel")}
                          </Form.Group>
                        </Col>
                      </>
                    )
                    }
                    {formData.staff_type == "Aided" && formData.gender == "Female" && formData.desig_id !== "1" && (
                      <Col lg={4} md={6} sm={12}>
                        <Form.Group>
                          <Form.Label>Maternity Leave</Form.Label>
                          <Form.Control
                            name="maternity_leave"
                            type="text"
                            value={formData.maternity_leave}
                            onChange={(e) => setFormData({ ...formData, maternity_leave: e.target.value.toUpperCase() })}
                            placeholder="0"
                          />
                          {renderError("maternity_leave")}
                        </Form.Group>
                      </Col>
                    )}
                    {formData.desig_id !== "1" && formData.desig_id !== "2" && (
                      <>
                    <Col lg={4} md={6} sm={12}>
                      <Form.Group>
                        <Form.Label>Taken OD Count</Form.Label>
                        <Form.Control
                          name="od_count"
                          type="text"
                          value={formData.od_count}
                          onChange={(e) => setFormData({ ...formData, od_count: e.target.value.toUpperCase() })}
                          placeholder="0"
                        />
                        {renderError("od_count")}
                      </Form.Group>
                    </Col>
          
                    <Col lg={4} md={6} sm={12}>
                      <Form.Group>
                        <Form.Label>Total Permission</Form.Label>
                        <Form.Control
                          name="total_permission"
                          type="text"
                          value={formData.total_permission}
                          onChange={(e) => setFormData({ ...formData, total_permission: e.target.value.toUpperCase() })}
                          placeholder="0"
                        />
                        {renderError("total_permission")}
                      </Form.Group>
                    </Col>
          
                    <Col lg={4} md={6} sm={12}>
                      <Form.Group>
                        <Form.Label>Taken Permission</Form.Label>
                        <Form.Control
                          name="taken_permission"
                          type="text"
                          value={formData.taken_permission}
                          onChange={(e) => setFormData({ ...formData, taken_permission: e.target.value.toUpperCase() })}
                          placeholder="0"
                        />
                        {renderError("taken_permission")}
                      </Form.Group>
                    </Col>
          
                    <Col lg={4} md={6} sm={12}>
                      <Form.Group>
                        <Form.Label>Remaining Permission</Form.Label>
                        <Form.Control
                          name="remaining_permission"
                          type="text"
                          value={formData.remaining_permission}
                          onChange={(e) => setFormData({ ...formData, remaining_permission: e.target.value.toUpperCase() })}
                          placeholder="0"
                        />
                        {renderError("remaining_permission")}
                      </Form.Group>
                    </Col>
</>
                    )}
          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Basic Salary</Form.Label>
              <Form.Control
                name="basic_salary"
                type="text"
                value={formData.basic_salary}
                onChange={(e) => setFormData({ ...formData, basic_salary: e.target.value.toUpperCase() })}
                placeholder="0.00"
              />
              {renderError("basic_salary")}
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <Button type="submit" className="btn-submit">
            Update
          </Button>
          <Button
            className="btn-top"
            onClick={() => window.history.back()}
          >
            Cancel
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default EditCustomer;
